import { API_URL } from "../config";
import { useCallback, useEffect, useRef, useState } from "react";

const buildPathWithParams = (path, params) => {
  if (!params) return path;
  return path.replace(/{([^}]+)}/g, (_, key) => params[key] ?? `{${key}}`);
};

export const useQuery = ({
  url,
  options = {},
  onFetch,
  onError,
  pathParams: initialPathParams = null,
  lazy = false,
}) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pathParams, setPathParams] = useState(initialPathParams);
  const shouldFetchRef = useRef(!lazy);

  /*************  ✨ Windsurf Command 🌟  *************/
  const fetchData = useCallback(
    async (overridePathParams = null) => {
      if (!url || !shouldFetchRef.current) return;
      shouldFetchRef.current = false;

      const currentParams = overridePathParams ?? pathParams;

      setLoading(true);
      try {
        const token = localStorage.getItem("token");
        const finalUrl = buildPathWithParams(url, currentParams);
        const response = await fetch(`${API_URL}${finalUrl}`, {
          ...options,
          headers:
            token === null
              ? options.headers
              : { ...options.headers, Authorization: `Bearer ${token}` },
        });

        if (!response.ok) {
          if (response.status === 403) {
            window.location.href = "/#/auth/login";
          }
          if (!response.ok)
            throw new Error(`Error ${response.status}: ${response.statusText}`);
        }

        const result = response.status === 204 ? null : await response.json();
        setData(result);
        onFetch?.(result);
      } catch (err) {
        setError(err);
        onError?.(err);
      } finally {
        setLoading(false);
      }
    },
    [url, options, onFetch, onError, pathParams]
  );
  /*******  51b92702-c39b-46f0-a290-37161f2d8c77  *******/

  useEffect(() => {
    if (!lazy) {
      fetchData();
    }
  }, [fetchData, lazy]);

  const execute = async ({ pathParams: newPathParams } = {}) => {
    if (newPathParams) setPathParams(newPathParams);
    shouldFetchRef.current = true;
    await fetchData(newPathParams); // <-- forzamos usar los nuevos
    return data;
  };

  return { data, error, loading, execute };
};
